var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4992 3.9386C13.8473 5.8716 14.9944 10.1527 13.0614 13.5008C11.1284 16.8488 6.84726 17.996 3.49922 16.063C0.151168 14.13 -0.995959 9.84883 0.937038 6.50078C1.10544 6.20911 1.29165 5.93414 1.49352 5.67645C1.69513 5.4191 2.08414 5.45801 2.28665 5.71466C2.56438 6.06663 2.8807 6.38674 3.22922 6.66862C3.56186 6.93764 4.01598 6.62041 4.00255 6.19281C4.00055 6.1291 3.99954 6.06514 3.99954 6.00095C3.99954 5.0824 4.20594 4.21207 4.5749 3.4338C5.10805 2.30919 5.98062 1.37681 7.0603 0.76896C7.30729 0.629909 7.61076 0.753179 7.73727 1.00682C8.32922 2.19368 9.26457 3.22578 10.4992 3.9386ZM10.9995 11.001C10.9995 13.2101 9.20867 15.001 6.99953 15.001C5.08625 15.001 3.47861 13.6025 3.08968 11.8193C2.99611 11.3903 3.52918 11.1759 3.90347 11.4054C4.3895 11.7035 4.93682 11.8974 5.50489 11.9694C5.80752 12.0078 6.03561 11.7299 6.01433 11.4256C6.00452 11.2853 5.99953 11.1437 5.99953 11.001C5.99953 9.57408 6.49763 8.26351 7.32943 7.23367C7.43324 7.10514 7.59847 7.04206 7.76071 7.07331C9.60581 7.42878 10.9995 9.05212 10.9995 11.001Z",
    fill: "#F83C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlame);
export default __webpack_public_path__ + "static/media/flame.e7c2f3ad607a8b2dbf4acd0368eba890.svg";
export { ForwardRef as ReactComponent };